import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setAppId: (state, action: PayloadAction<string>) => {
      state.app_id = action.payload;
    },
    setAppName: (state, action: PayloadAction<string>) => {
      state.app_name = action.payload;
    },
    setAppStatus: (state, action: PayloadAction<string>) => {
      state.app_status = action.payload;
    },
    setRegion: (state, action: PayloadAction<string>) => {
      state.region = action.payload;
    },
    toggleChatsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_chats_enabled = action.payload;
    },
    toggleChatBotEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_chat_bot_enabled = action.payload;
    },
    toggleCallsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_calls_enabled = action.payload;
    },
    toggleScheduledCallsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_scheduled_calls_enabled = action.payload;
    },
    toggleNotificationsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_notifications_enabled = action.payload;
    },
    toggleExportDataAccess: (state, action: PayloadAction<boolean>) => {
      state.is_export_data_access_enabled = action.payload;
    },
    toggleChatAnalyticsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_chat_analytics_enabled = action.payload;
    },
    toggleCallAnalyticsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_call_analytics_enabled = action.payload;
    },
    toggleSentimentAnalysisEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_sentiment_analysis_enabled = action.payload;
    },
    toggleUserAnalyticsEnabled: (state, action: PayloadAction<boolean>) => {
      state.is_user_analytics_enabled = action.payload;
    },
    toggleFetchData: (state, action: PayloadAction<boolean>) => {
      state.is_fetch_data = action.payload;
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primary_color = action.payload;
    },
    setSecondaryColor: (state, action: PayloadAction<string>) => {
      state.secondary_color = action.payload;
    },
    clearApplicationDetails: (state) => {
      state.app_id = '';
      state.app_name = '';
      state.app_status = '';
      state.region = '';
      state.is_chats_enabled = false;
      state.is_chat_bot_enabled = false;
      state.is_calls_enabled = false;
      state.is_scheduled_calls_enabled = false;
      state.is_notifications_enabled = false;
      state.is_export_data_access_enabled = false;
      state.is_chat_analytics_enabled = false;
      state.is_call_analytics_enabled = false;
      state.is_sentiment_analysis_enabled = false;
      state.is_user_analytics_enabled = false;
      state.is_fetch_data = false;
      state.primary_color = '#1976d2';
      state.secondary_color = '#dc004e';
    },
  },
});

export const {
  setAppId,
  setAppName,
  setAppStatus,
  setRegion,
  toggleChatsEnabled,
  toggleChatBotEnabled,
  toggleCallsEnabled,
  clearApplicationDetails,
  toggleScheduledCallsEnabled,
  toggleNotificationsEnabled,
  toggleExportDataAccess,
  toggleChatAnalyticsEnabled,
  toggleCallAnalyticsEnabled,
  toggleSentimentAnalysisEnabled,
  toggleUserAnalyticsEnabled,
  toggleFetchData,
  setPrimaryColor,
  setSecondaryColor,
} = applicationSlice.actions;
export default applicationSlice.reducer;
